import { createTheme } from "@mui/material/styles";
import { deDE } from "@mui/material/locale";

export function lightTheme() {
  return createTheme(
    {
      palette: {
        primary: { main: "#245ca2" },
        secondary: { main: "#af1816" },
        brand: { red: "#af1816", blue: "#245ca2" },
      },
      // Centralize specific MUI component color rules here so App.css doesn't need hard-coded colors.
      components: {
        // Tooltip font size and placement set to fulfill dropdown menu requirement (12pt, right side)
        MuiTooltip: {
          defaultProps: {
            placement: "right", // Default dropdown option tooltips to right side
          },
          styleOverrides: {
            tooltip: ({ theme }) => ({
              fontSize: theme.typography.pxToRem(12),
            }),
          },
        },

        MuiIconButton: {
          styleOverrides: {
            root: ({ theme }) => ({ color: theme.palette.brand.red }),
          },
        },
        MuiSelect: {
          styleOverrides: {
            icon: ({ theme }) => ({ color: theme.palette.brand.red }),
          },
        },
        // MuiAccordionSummary: {
        //   styleOverrides: {
        //     root: ({ theme }) => ({backgroundColor: theme.palette.brand.main }),
        //   },
        // },
      },
    },
    deDE,
  );
}
